const TWEEN = require('@tweenjs/tween.js')

const calculateDuration = (direction, defaultDuration, propsDuration) => {
  let dur = defaultDuration
  if (propsDuration !== undefined) {
    if (typeof propsDuration === 'object') {
      if (propsDuration[direction] !== undefined) dur = propsDuration[direction]
      else dur = defaultDuration
    } else {
      dur = propsDuration
    }
  }
  return dur
}

export default {
  name: 'slide-transition',
  functional: true,
  render: (createElement, context) => {
    const defaultDirection = 'left'
    const defaultTransitionPosition = 'static'
    // const defaultMode = 'out-in'
    const defaultDuration = 250
    const transitionMap = {
      left: {
        prop: 'translateX',
        dist: -10
      },
      right: {
        prop: 'translateX',
        dist: 10
      },
      up: {
        prop: 'translateY',
        dist: 10
      },
      down: {
        prop: 'translateY',
        dist: -10
      }
    }
    let data = {
      props: Object.assign({}, {
        name: 'slide-transition',
        css: false
      }, context.props),
      on: {
        beforeEnter (el) {
          const position = context.props.position
          el.style.position = position && position.start ? context.props.position.start : defaultTransitionPosition
          el.style.opacity = 0
        },
        enter (el, done) {
          const settings = transitionMap[context.props.direction || defaultDirection]
          const intitalTweenSettings = { position: settings.dist, opacity: 0 }
          const finaltTweenSettings = { position: 0, opacity: 1 }
          const tween = new TWEEN.Tween(intitalTweenSettings)
          tween.to(finaltTweenSettings, calculateDuration('enter', defaultDuration, context.props.duration))
          .onUpdate((object) => {
            el.style.transform = `${settings.prop}(${object.position}px)`
            el.style.opacity = `${object.opacity}`
          })
          .onComplete(() => {
            const position = context.props.position
            el.style.position = position && position.end ? context.props.position.end : defaultTransitionPosition
            done()
          })

          function animate (time) {
            requestAnimationFrame(animate)
            TWEEN.update(time)
          }
          requestAnimationFrame(animate)

          tween.start()
        },

        beforeLeave (el) {
          const position = context.props.position
          el.style.position = position && position.start ? context.props.position.start : defaultTransitionPosition
        },

        leave (el, done) {
          const settings = transitionMap[context.props.direction || defaultDirection]
          const intitalTweenSettings = { position: 0, opacity: 1 }
          const finaltTweenSettings = { position: settings.dist, opacity: 0 }
          const tween = new TWEEN.Tween(intitalTweenSettings)
          tween.to(finaltTweenSettings, calculateDuration('enter', defaultDuration, context.props.duration))
          .onUpdate((object) => {
            el.style.transform = `${settings.prop}(${object.position}px)`
            el.style.opacity = `${object.opacity}`
          })
          .onComplete(() => {
            const position = context.props.position
            el.style.position = position && position.end ? context.props.position.end : defaultTransitionPosition
            done()
          })

          function animate (time) {
            requestAnimationFrame(animate)
            TWEEN.update(time)
          }
          requestAnimationFrame(animate)

          tween.start()
        }
      }

    }
    return createElement('transition', data, context.children)
  }
}
